<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('DriverManagement.num')">
                    <el-select
                      v-model="formInline.selectCarType"
                      style="width: 120px"
                      :placeholder="$t('common.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.selectCarValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.linkState')">
                    <el-select
                      v-model="formInline.linkState"
                      :placeholder="$t('DriverManagement.form.linkState')"
                      filterable
                      size="mini"
                      style="width: 120px; margin-left: 5px"
                    >
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option
                        :label="$t('DriverManagement.onLine')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('DriverManagement.offLine')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.authorizes')">
                    <el-input-number
                      size="mini"
                      v-model="formInline.authorizeCountLower"
                      controls-position="right"
                      :min="0"
                      :max="10000"
                    ></el-input-number>
                    <span>{{ $t("DriverManagement.to") }}</span>
                    <el-input-number
                      size="mini"
                      v-model="formInline.authorizeCountUpper"
                      controls-position="right"
                      :min="0"
                      :max="10000"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('AUTHORIZATIONMANAGEMENT_EMPTY')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="CancelSend"
                  >{{ $t("DriverManagement.btn.cancelSend") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('AUTHORIZATIONMANAGEMENT_DRIVERSYNCHRONIZATION')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="syncDriver"
                  >{{ $t("DriverManagement.btn.syncDriver") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('AUTHORIZATIONMANAGEMENT_FINGERPRINTSYNCHRONIZATION')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="synchro"
                  >{{ $t("DriverManagement.btn.synchro") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('AUTHORIZATIONMANAGEMENT_ADD')"
                  type="text"
                  @click="addSimple"
                  :disabled="selected.length != 1"
                  >{{ $t("DriverManagement.btn.addAuthorize") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('AUTHORIZATIONMANAGEMENT_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="$t('DriverManagement.btn.addAuthorize')"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="terminalId"
            :label="$t('DriverManagement.terminalId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              v-model="form.terminalId"
              :placeholder="$t('DriverManagement.form.terminalId')"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="authorizeType"
            :label="$t('DriverManagement.authorizeType') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="form.authorizeType"
              :placeholder="$t('DriverManagement.form.authorizeType')"
              filterable
            >
              <el-option
                :label="$t('DriverManagement.fingerAuthorize')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('DriverManagement.keyAuthorize')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('DriverManagement.faceAuthorize')"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.authorizePower') + ':'"
            :label-width="formLabelWidth"
            prop="authorizePower	"
          >
            <el-select
              v-model="form.authorizePower"
              :placeholder="$t('DriverManagement.form.authorizePower')"
            >
              <el-option
                :label="$t('DriverManagement.normalAuthorize')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('DriverManagement.adminAuthorize')"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.authorizeDriver') + ':'"
            :label-width="formLabelWidth"
            prop="driverNum"
          >
            <el-select
              v-model="form.driverNum"
              filterable
              :placeholder="$t('DriverManagement.form.driverNum')"
            >
              <el-option
                v-for="item in driveList"
                :key="item.driverNum"
                :label="item.name"
                :value="item.driverNum"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('common.btn.operate')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgSearch">
          <el-form :inline="true" :model="formTable" class="demo-form-inline">
            <el-form-item :label="$t('DriverManagement.driverNum')">
              <el-input
                size="mini"
                v-model="formTable.driverNum"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('DriverManagement.name')">
              <el-input
                size="mini"
                v-model="formTable.driverName"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="mini"
                type="primary"
                @click="Search"
                class="btn-chaxun"
                >{{ $t("common.btn.search") }}</el-button
              >
              <el-button size="mini" @click="Clear" class="btn-del">{{
                $t("common.btn.cancel")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="zMsgBtn">
          <el-button type="text" @click="down">{{
            $t("common.btn.download")
          }}</el-button>
        </div>
        <div class="zMsgTable">
          <i-table
            :list="authorizeList"
            :height="authorizeHeight"
            ref="authorizeTable"
            @handleSelectionChange="handleAuthorizeChange"
            :options="option"
            :columns="authorizeColumns"
            :operates="authorizeOperates"
          ></i-table>
          <IPaginations
            ref="AuthorizePage"
            @PageFun="changeAuthorizeSize"
          ></IPaginations>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AuthorizationManagement from "./AuthorizationManagement.js";
export default AuthorizationManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
